<template>
    <router-link :to="`/invites/${invitationCode.code}`">
        <div
            class="px-6 py-2 border border-gray-100 rounded shadow-sm hover:shadow transition duration-150"
        >
            <div class=" flex items-center">
                <div class="flex-1 flex justify-between">
                    <div class="flex flex-col">
                        <span> {{ invitationCode.code }} </span>
                        <span> {{ invitationCode.passwordResetLink }} </span>

                        <ul
                            v-if="invitationCode.groups"
                            class="space-x-2 flex flex-wrap items-center mt-1"
                        >
                            <li
                                v-for="s in invitationCode.groups"
                                :key="s"
                                class="border border-gray-500 rounded-full px-3 leading-6 text-sm font-medium text-gray-800"
                            >
                                <span>{{ groupName(s) }}</span>
                            </li>
                        </ul>
                    </div>
                    <span>
                        {{ invitationCode.memo }}
                    </span>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    props: ['invitationCode', 'groups'],
    methods: {
        groupName(g) {
            const group = this.groups.find(i => i.id == g)
            if (group) return group.tag
            return g
        },
    },
}
</script>
